<template>
    <b-container>
        <div class="lightbox" @click="$emit('close')">
            <span class="close-btn cursor" @click.stop.prevent="$emit('close')">&times;</span>
            <div class="slider-container">
                <div class="slider-content">
                    <span v-for="image in imageList">    
                        <div v-if="image == imageList[currentImage]" class="slider-single active" @click.stop.prevent="slideRight">
                            <img :src="image" class="slider-single-image">
                        </div>
                        <div v-else-if="image == nextImage" class="slider-single proactive" @click.stop.prevent="slideRight">
                            <img :src="image" class="slider-single-image">
                        </div>
                        <div v-else-if="image == prevImage " class="slider-single preactive" @click.stop.prevent="slideLeft">
                            <img :src="image" class="slider-single-image">
                        </div>
                        <div v-else class="slider-single proactivede" @click.stop.prevent="slideRight">
                            <img :src="image" class="slider-single-image">
                        </div>
                    </span>
                    <span v-if="imageList.length > 1" class="slider-left display-4" @click.stop.prevent="slideLeft">&#10094;</span>
                    <span v-if="imageList.length > 1" class="slider-right display-4" @click.stop.prevent="slideRight">&#10095;</span>
                </div>
            </div>
        </div>
    </b-container>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            imageList: null,
            currentImage: 0,
            
        }
    },
    methods: {
        getAlbumImages(path) {
            axios.get(path).then((response) => {
                this.imageList = response.data
            }, (error) => {
                console.log(error)
            })
            
        },

        slideRight(){
            if ((this.imageList.length - 1) <= this.currentImage) {
                this.currentImage = 0;
                return false
            }
            this.currentImage += 1
        },

        slideLeft(){
            if (this.currentImage <= 0) {
                this.currentImage = this.imageList.length - 1
                return false
            }
            this.currentImage -= 1
        },
    },
    props: {
        album_id: {
            default: 0,
            type: Number,
        }
    },
    computed: {
        prevImage(){
            return this.imageList.slice(this.currentImage - 1)[0];
        },

        nextImage(){
            if (this.imageList.length <= (this.currentImage + 1)){
                return this.imageList[0];
            } else {
                return this.imageList.slice(this.currentImage + 1)[0];
            }
        }
    },
    beforeCreate() {
        
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        window.addEventListener('keyup', (event) => {
            if (this.imageList){
                if (event.keyCode === 27) {
                    this.$emit('close')
                }
                // If left arrow was pressed...
                if (event.keyCode === 37) { 
                    this.slideLeft();
                }
                // If right arrow was pressed...
                if (event.keyCode === 39) { 
                    this.slideRight();
                }
            }
        })
    },
    beforeUpdate() {
        
    },
    updated() {

    }
}
</script>
<style>


.prev-btn,
.next-btn {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -50px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: bold;
  font-size: 20px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
  -webkit-user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/LightBox.vue